/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import BorderCenter from 'solis/react/board/hex/border.center';


export default (props) =>
(
  <>
    <BorderCenter {...props} index = {0} />
    <BorderCenter {...props} index = {1} />
    <BorderCenter {...props} index = {2} />
    <BorderCenter {...props} index = {3} />
    <BorderCenter {...props} index = {4} />
    <BorderCenter {...props} index = {5} />
  </>
);
